// extracted by mini-css-extract-plugin
export default {"root":"AddMenteeModuleModal_root__ZK41e","modalInput":"AddMenteeModuleModal_modalInput__2UhC9"};